import { CUSTOMERS_DROPDOWN, EXPORT_REPORT, GENERATE_BILL, PRODUCT_DROPDOWN, SUBSCRIPTIONS_LIST, TRANSACTIONS_LIST } from "./types";


export const generateBillAction = (data, onSuccess, onError) => {
    return {
        type: GENERATE_BILL,
        data,
        onSuccess,
        onError,
    };
};

export const transactionsListAction = (data, onSuccess, onError) => {
    return {
        type: TRANSACTIONS_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const productDropdownAction = (data, onSuccess, onError) => {
    return {
        type: PRODUCT_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const exportReportAction = (data, onSuccess, onError) => {
    return {
        type: EXPORT_REPORT,
        data,
        onSuccess,
        onError,
    };
};

export const subscriptionsListAction = (data, onSuccess, onError) => {
    return {
        type: SUBSCRIPTIONS_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const customersListAction = (data, onSuccess, onError) => {
    return {
        type: CUSTOMERS_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};